import { HttpStatusCode } from "@next-platform/packages-ts-types";
import { PageBlockTransportErrorCategory } from "./PageBlockTransportErrorCategory";
const TERMINAL_HTTP_STATUSES = new Set([
    HttpStatusCode.BAD_REQUEST,
    HttpStatusCode.UNAUTHORIZED,
    HttpStatusCode.FORBIDDEN,
    HttpStatusCode.NOT_FOUND,
]);
const TRANSIENT_HTTP_STATUSES = new Set([HttpStatusCode.BAD_GATEWAY, HttpStatusCode.SERVICE_UNAVAILABLE]);
export default function mapHttpStatusToPageBlockTransportErrorCategory(httpStatus) {
    if (TERMINAL_HTTP_STATUSES.has(httpStatus)) {
        return PageBlockTransportErrorCategory.TERMINAL;
    }
    if (TRANSIENT_HTTP_STATUSES.has(httpStatus)) {
        return PageBlockTransportErrorCategory.TRANSIENT;
    }
    return PageBlockTransportErrorCategory.UNEXPECTED;
}
